<template>
  <div class="pageWrapper">
    <div class="firstSection eachSectionMargin">
      <v-row @click="sessionDetailModal = !sessionDetailModal" no-gutters>
        <v-col cols="1">
          <img
            src="@/assets/newPreSession/greenSleeve.gif"
            alt=""
            class="sleeve"
          />
        </v-col>
        <v-col cols="11">
          <div style="color: #212121" class="body-medium-16-medium">
            {{ $t("newPreSession.sessionHelpText") }}
          </div>
        </v-col>

        <div
          style="color: #035184"
          class="sessionDetailRow body-medium-16-medium d-flex flex-row justify-end"
        >
          <div class="body-medium-16-medium">
            {{ $t("newPreSession.sessionInfoView") }}
          </div>
          <div class="d-flex flex-column justify-center">
            <img
              src="@/assets/newPreSession/arrowLeft.png"
              alt=""
              class="leftArrow"
              :style="{'transform' : !$vuetify.rtl ? 'rotate(180deg)' : '' }"


            />
          </div>
        </div>
      </v-row>
    </div>

    <div id="presessionHasNoAvailableTimes" v-if="emptyState" class="mt-3">
      <div class="emptyPanel text-center">
        <img
          src="@/assets/newPreSession/emptyState.png"
          alt=""
          class="emptyImage"
        />

        <div style="color: #212121" class="body-medium-16-medium mt-4">
          {{ $t("newPreSession.noAvailableTimes") }}
        </div>
        <div style="color: #212121" class="body-medium-16-medium">
          {{ $t("newPreSession.notifyNewSlot") }}
        </div>
        <div class="whatsAppSection">
          <div style="color: #424242" class="body-small-14-medium text-center">
            {{ $t("newPreSession.contactViaWhatsAppText") }}
          </div>
          <div>
            <a
              style="color: #39c990"
              href="https://wa.me/00989302672054"
              target="_blank"
              class="whatsAppButton text-center title-small-16"
            >
              <img
                src="@/assets/newPreSession/whatsapp.png"
                alt=""
                class="whatsAppIcon"
              />

              {{ $t("newPreSession.reserveOnWhatsApp") }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="secondSection eachSectionMargin">
        <div class="body-small-14-medium" style="color: #616161">
          {{ $t("newPreSession.timezoneLabel") }}
        </div>
        <v-row no-gutters class="mt-2">
          <v-col cols="6" class=""> {{ selectedTimeZone }}</v-col>
          <v-col cols="6" class="body-medium-16-medium">
            <div
              @click="timezoneDetailModal = !timezoneDetailModal"
              style="color: #035184"
              class="body-medium-16-medium d-flex flex-row justify-end"
            >
              <div class="body-medium-16-medium">
                {{ $t("newPreSession.changeTimezone") }}
              </div>

              <div class="d-flex flex-column justify-center">
                <img
                  src="@/assets/newPreSession/arrowLeft.png"
                  alt=""
                  class="leftArrow"
                  :style="{'transform' : !$vuetify.rtl ? 'rotate(180deg)' : '' }"

                />
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      <div :class="{ 'is-locked': isFormLocked }">
        <div class="thirdSection eachSectionMargin">
          <div class="d-flex flex-row">
            <div class="d-flex flex-column justify-center">
              <img
                src="@/assets/newPreSession/notebook.gif"
                alt=""
                :class="$vuetify.rtl ? 'notebookImage' : 'notebookImageRtl'"
              />
            </div>
            <div
              class="d-flex flex-column justify-center body-medium-16-medium"
            >
              {{ $t("newPreSession.preferredTime") }}
            </div>
          </div>

          <v-radio-group
            class="my-radio-group"
            :value="selectedTimeOption"
            style="margin: 0 !important"
          >
            <div
              @click="
                () => {
                  selectedTimeOption = 'closest';
                }
              "
              :style="{
                'border-color':
                  selectedTimeOption === 'closest' ? '#39C990' : '#EAF0F6',
              }"
              :class="[
                'eachBoxStyle mt-4',

                { selectedBorder: selectedTimeOption === 'closest' },
              ]"
            >
              <div
                style="color: #424242"
                class="body-medium-16-medium"
                :class="$vuetify.rtl ? 'text-right' : 'text-left'"
              >
                {{ $t("newPreSession.closestTime") }}
              </div>

              <div style="color: #616161" class="d-flex flex-row mt-2">
                <v-radio
                  value="closest"
                  style="display: inline !important; margin: 0 !important"
                >
                </v-radio>
                <div class="body-medium-16-medium">
                  {{ closestTime }}
                </div>
              </div>
              <div
                v-if="timesRefreshed"
                class="cautionContainer"
                :class="{ animateCaution: animateBorder }"
              >
                <div class="d-flex justify-center align-center">
                  <img
                    src="@/assets/newPreSession/caution.png"
                    alt=""
                    class="cautionImage"
                  />
                </div>
                <div class="body-small-14-medium" style="color: #fead20">
                  {{ $t("newPreSession.timesUpdated") }}
                </div>
              </div>
            </div>
            <div
              @click="
                () => {
                  selectedTimeOption = 'fixed';
                }
              "
              :style="{
                'border-color':
                  selectedTimeOption !== 'closest' ? '#39C990' : '#EAF0F6',
              }"
              class="eachBoxStyle mt-4"
            >
              <div
                style="color: #616161"
                class="d-flex flex-row mt-2 body-medium-16-medium"
              >
                <v-radio
                  value="fixed"
                  style="display: inline !important; margin: 0 !important"
                >
                </v-radio>
                <div class="body-medium-16-medium">
                  {{ $t("newPreSession.calendarAndOtherTimes") }}
                </div>
              </div>
            </div>
          </v-radio-group>
        </div>
      </div>

      <div
        v-if="selectedTimeOption === 'fixed'"
        class="fourthSection eachSectionMargin"
      >
        <div
          class="eachTimeBox"
          v-for="eachDay in availableTimes.slice(0, 7)"
          :key="eachDay.date"
          @click="onSelectingDate(eachDay.date)"
          :class="{
            selectedDay: selectedDate === eachDay.date,
            disabledDay: eachDay.disabled,
          }"
        >
          <div style="color: #616161" class="body-medium-16-medium">
            {{ getDayName(eachDay.date) }}
          </div>
          <div style="color: #616161" class="">
            {{ formatEachDate(eachDay.date) }}
          </div>
          <div
            class="body-small-14-regular mt-2"
            :style="{
              color: eachDay.periods.length >= 3 ? '#00C853' : '#ff5252',
            }"
          >
            <span class="caption-large-12-medium" v-if="eachDay.periods.length">
              {{ eachDay.periods.length }}
              {{$t("newPreSession.times")}}

            </span>
            <span v-else>-</span>
          </div>
        </div>
      </div>

      <div v-if="selectedDate" class="timesOfWeek">
        <v-tabs
          v-model="selectedTab"
          fixed-tabs
          color="#39C990"
          background-color="white"
          show-arrows
        >
          <v-tab class="title-small-16">{{$t('newPreSession.morning')}}</v-tab>
          <v-tab class="title-small-16">{{$t('newPreSession.afternoon')}}</v-tab>
          <v-tab class="title-small-16">{{$t('newPreSession.evening')}}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="selectedTab">
          <v-tab-item>
            <div v-if="morningTimes.length" class="time-row eachSectionMargin">
              <div
                @click="selectedDayTime = eachTime.id"
                v-for="eachTime in morningTimes"
                :key="eachTime.id"
                class="time-box eachDayTime body-small-14-medium"
                :class="{ selectedDay: selectedDayTime === eachTime.id }"
              >
                {{ eachTime.time }}
              </div>
            </div>
            <div
              style="color: #616161"
              v-else
              class="body-small-14-medium timeSection text-center"
            >
              {{ $t("newPreSession.noEmptySlots") }}
            </div>
          </v-tab-item>
          <v-tab-item>
            <div
              v-if="afternoonTimes.length"
              class="time-row eachSectionMargin"
            >
              <div
                @click="selectedDayTime = eachTime.id"
                v-for="eachTime in afternoonTimes"
                :key="eachTime.id"
                class="time-box eachDayTime body-small-14-medium"
                :class="{ selectedDay: selectedDayTime === eachTime.id }"
              >
                {{ eachTime.time.replace("Afternoon","AM") }}
              </div>
            </div>
            <div
              style="color: #616161"
              v-else
              class="body-small-14-medium timeSection text-center"
            >
              {{$t("newPreSession.noEmptySlots")}}
            </div>
          </v-tab-item>
          <v-tab-item>
            <div v-if="nightTimes.length" class="time-row eachSectionMargin">
              <div
                @click="selectedDayTime = eachTime.id"
                v-for="eachTime in nightTimes"
                :key="eachTime.id"
                class="time-box eachDayTime body-small-14-medium"
                :class="{ selectedDay: selectedDayTime === eachTime.id }"
              >
                {{ eachTime.time.replace("Evening","PM") }}
              </div>
            </div>
            <div
              style="color: #616161"
              v-else
              class="body-small-14-medium timeSection text-center"
            >
              {{$t("newPreSession.noEmptySlots")}}
             </div>
          </v-tab-item>
        </v-tabs-items>
        <div class="bottomSpacing"></div>
      </div>
      <div class="bottomSpacing"></div>

      <v-row no-gutters class="footerFixed">
        <v-col cols="6" class="d-flex align-center justify-center">
          <div class="">
            <div v-if="finalDate">
              <span class="body-medium-16-medium">{{
                finalDate.split(",")[0] ?? ""
              }}</span>
            </div>
            <div v-else>
              <span style="color: #424242" class="body-medium-16-medium">
                {{ $t("newPreSession.chooseDateTime") }}
              </span>
            </div>
          </div>
        </v-col>
        <v-col cols="6" class="d-flex align-center justify-center">
          <div
            id="new-pre-session-step-two-free-time"
            @click="submitForm"
            :class="['submitBtn', { 'is-disabled': loading || isFormLocked }]"
          >
            {{$t("newPreSession.confirmAndContinue")}}
          </div>
        </v-col>
      </v-row>
    </div>
    <v-bottom-sheet v-model="sessionDetailModal">
      <div class="sessionDetailModal">
        <div class="sessionDetailHeader">
          <div class="d-flex flex-column justify-center">
            <img
              src="@/assets/newPreSession/info.png"
              alt=""
              class="smallIcon"
            />
          </div>
          <div
            class="body-large-18-medium d-flex flex-column justify-center flex-grow-1 mt-1 mr-2"
          >
            {{$t("newPreSession.sessionInfo")}}
          </div>
          <div class="d-flex flex-column justify-center">
            <img
              @click="sessionDetailModal = false"
              src="@/assets/newPreSession/cross.png"
              alt=""
              class="smallIcon"
            />
          </div>
        </div>
        <div class="divider"></div>
        <div class="theInfoSection body-medium-16-regular">
          <ul style="color: #424242" class="">
            <li class="body-medium-16-regular">
              <span class="infoLabel body-medium-16-medium">{{$t("newPreSession.sessionDuration")}}</span>
              <span class="infoValue body-medium-16-medium"> ۱۵ {{$t("newPreSession.min")}}</span>
            </li>
            <li class="body-medium-16-regular">
              {{$t("newPreSession.sessionOrganizer")}}
              {{$t("newPreSession.sessionOrganizerText")}}

            </li>
            <li class="body-medium-16-regular">
              {{$t("newPreSession.sessionLocation")}}
              {{$t("newPreSession.sessionLocationText")}}

            </li>
          </ul>
        </div>
        <div class="bottomMargin"></div>
      </div>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="timezoneDetailModal">
      <div class="timezoneModal">
        <div class="sessionDetailHeader">
          <div
            class="body-large-18-medium d-flex flex-column justify-center flex-grow-1 mt-1 mr-2"
          >
            {{$t("newPreSession.timezoneModalTitle")}}
          </div>
          <div class="d-flex flex-column justify-center">
            <img
              @click="timezoneDetailModal = false"
              src="@/assets/newPreSession/cross.png"
              alt=""
              class="smallIcon"
            />
          </div>
        </div>
        <div class="divider"></div>
        <div class="timezoneInputWrapper">
          <v-text-field
            class="timezoneInput body-small-14-regular"
            :label="$t('newPreSession.selectTimezone')"
            v-model="timezoneSearch"
            @input="onTimezoneSearch"
            item-text="name"
            item-value="value"
            outlined
          >
            <template v-slot:prepend-inner>
              <img
                src="@/assets/newPreSession/search.png"
                alt="timezone icon"
                class="searchIcon"
              />
            </template>
          </v-text-field>

          <div
            style="overflow: scroll; height: 65vh"
            class="mt-2"
            v-if="timezoneSearchResult.length"
          >
            <div
              v-for="(item, index) in timezoneSearchResult"
              :key="index"
              class="mt-5"
            >
              <v-row @click="onSelectingTimeZone(item.text)" no-gutters>
                <v-col cols="1" class="d-flex align-center justify-center">
                  <img
                    src="@/assets/newPreSession/world.png"
                    alt=""
                    class="globeImg"
                  />
                </v-col>
                <v-col cols="11" class=" ">
                  {{ item.text }}
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </v-bottom-sheet>
  </div>
</template>

<script>
/*eslint-disable*/
import moment from "moment-timezone";
import momentJalali from "moment-jalaali";
import { mapGetters } from "vuex";
import EventsMixins from "@/mixins/EventsMixins";

export default {
  mixins:[EventsMixins],
  data() {
    return {
      sessionDetailModal: false,
      timezoneDetailModal: false,
      timezoneSearch: "",
      timezoneSearchResult: [],
      throttleTimeout: null,
      throttleDelay: 300,
      selectedDayOfWeek: null,
      selectedTimeOfWeek: null,
      isExpanded: false,
      closestTime: null,
      selectedTimeOption: "closest",
      selectedDayTime: null,
      selectedTab: 0,
      selectedDate: null,
      selectedTime: "",
      morningTimes: [],
      afternoonTimes: [],
      nightTimes: [],
      availableTimes: [],
      selectedTimeZone: null,
      finalDate: null,
      emptyState: false,
      closestTimeTemp: null,
      loading: false,
      isFormLocked: false,
      timesRefreshed: false,
      animateBorder: false,
    };
  },

  watch: {
    timesRefreshed(val) {
      if (val) {
        this.animateBorder = true;
        setTimeout(() => {
          this.animateBorder = false;
        }, 3000);
      }
    },
    selectedTimeOption() {
      if (this.selectedTimeOption === "closest") {
        this.finalDate = this.closestTimeTemp;
      } else {
        this.scrollToBottom();
      }
      this.selectedDate = null;
    },
    selectedDayTime() {
      let period = this.availableTimes
        .find((item) => item.date === this.selectedDate)
        .periods.filter(
          (eachPeriod) => eachPeriod.id === this.selectedDayTime
        )[0];
      this.finalDate =
        this.getDayName(this.selectedDate) +
        " " +
        this.selectedDate +
          this.$t("newPreSession.hourText") + " " +
        period.start +
        " " +
        this.getPersianTimeLabel(period.start) +
        " " +
        "," +
        `(${this.selectedTimeZone})`;
    },
  },
  computed: {
    ...mapGetters({ profile: "getProfile" }),
  },
  methods: {
    getPersianTimeLabel(timeString) {
      const [hour, minute] = timeString.split(":").map(Number);
      const totalMinutes = hour * 60 + minute;

      if (totalMinutes >= 0 && totalMinutes < 720) {
        return this.$t("newPreSession.morning");
      } else if (totalMinutes >= 720 && totalMinutes < 1080) {
        return this.$t("newPreSession.afternoon");
      } else {
        return this.$t("newPreSession.evening");
      }
    },
    generateDateTimes(date) {
      let periods = this.availableTimes.find(
        (item) => item.date === date
      ).periods;

      periods.map((item) => {
        if (this.getPersianTimeLabel(item.start) === this.$t("newPreSession.evening")) {
          this.nightTimes.push({
            id: item.id,
            time: item.start + this.$t("newPreSession.evening") + " ",
          });
        } else if (this.getPersianTimeLabel(item.start) === this.$t("newPreSession.afternoon")) {
          this.afternoonTimes.push({
            id: item.id,
            time: item.start + this.$t("newPreSession.afternoon") + " ",
          });
        } else {
          this.morningTimes.push({
            id: item.id,
            time: this.formatTimeWithAmPm(item.start),
          });
        }
      });

      if (this.morningTimes.length > 0) this.selectedTab = 0;
      else if (this.afternoonTimes.length > 0) this.selectedTab = 1;
      else this.selectedTab = 2;
    },
    formatEachDate(date) {
      return moment(date, "YYYY/MM/DD").format("MMM DD");
    },
    formatTimeWithAmPm(timeString) {
      if (this.$vuetify.rtl) {
        return moment(timeString, "HH:mm")
            .format("hh:mm A")
            .replace("AM", "صبح")
            .replace("PM", "شب");
      }
      else {
        return moment(timeString, "HH:mm")
            .format("hh:mm A")

      }

    },
    getDayName(date) {
      if (this.$vuetify.rtl) {
        return momentJalali(date, "YYYY/MM/DD").locale("fa").format("dddd");
      }
      else {
        return moment(date, "YYYY/MM/DD").locale("en").format("dddd");

      }
    },

    updateUserTimeZoneIfEmpty(newTimezone) {
      if (!this.profile.tz || this.profile.tz === "UTC" || newTimezone) {
        this.selectedTimeZone = newTimezone ?? this.prepareDefaultTimezone();
        if (!this.selectedTimeZone) {
          this.$emitEvent("notify", {
            title: this.$t('newPreSession.selectTimezoneError'),
            color: "red",
          });
          this.isFormLocked = true;
          this.loading = true;
          setTimeout(() => {
            this.timezoneDetailModal = true;
          }, 1500);
          return Promise.reject();
          return;
        }
        this.isFormLocked = false;

        return this.requesting("auth", "editProfile", "", {
          timezone: this.selectedTimeZone,
        });
      } else {
        this.selectedTimeZone = this.profile.tz;
        return Promise.resolve();
      }
    },
    fetchingTimes(newTimezone) {
      if (this.loading) {
        return;
      }
      this.$emitEvent("setLoading", true);
      this.loading = true;
      this.updateUserTimeZoneIfEmpty(newTimezone)
        .then(() => {
          this.requesting("preSessionRequests", "getEmptyTimes").then(
            (response) => {
              if (response.data.times.length !== 0) {
                this.availableTimes = response.data.times;
                let date = response.data.times[0].date;
                let closestTime = response.data.times[0].periods[0].start;

                this.closestTime =
                  this.getDayName(date) +
                  " " +
                  date +
                  " - " +
                    this.$t("newPreSession.hourText") + " " +
                  response.data.times[0].periods[0].start +
                  " " +
                  this.getPersianTimeLabel(closestTime);
                this.finalDate =
                  this.getDayName(date) +
                  " " +
                  date +
                    this.$t("newPreSession.hourText") + " " +
                  " " +
                  closestTime +
                  " " +
                  this.getPersianTimeLabel(closestTime) +
                  "," +
                  " " +
                  `(${this.selectedTimeZone})`;

                this.closestTimeTemp = this.finalDate;
              } else {
                this.emptyState = true;
              }
              setTimeout(() => {
                this.$emitEvent("setLoading", false);
                this.loading = false;
              }, 1500);
            }
          );
        })
        .catch(() => {
          this.$emitEvent("setLoading", false);
          this.loading = false;
        });
    },
    emptyDayTimes() {
      this.morningTimes = [];
      this.afternoonTimes = [];
      this.nightTimes = [];
    },
    normaliseTz(rawTz) {
      const canonical = this.timezoneAliases[rawTz] ?? rawTz;

      return this.timezones.some((t) => t.value === canonical)
        ? canonical
        : rawTz;
    },

    prepareDefaultTimezone() {
      try {
        const raw = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return this.normaliseTz(raw);
      } catch {
        return null;
      }
    },
    onSelectingDate(date) {
      this.selectedDate = date;
      this.emptyDayTimes();
      this.selectedTab = 0;
      this.generateDateTimes(date);
      this.scrollToBottom();
    },

    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },

    async submitForm() {
      if (this.loading) return;

      if (!this.selectedDayTime && this.selectedTimeOption !== "closest") {
        this.$emitEvent("notify", {
          color: "red",
          title: this.$t("newPreSession.selectTimeErrorText"),
        });
        return;
      }

      this.$emitEvent("setLoading", true);
      this.loading = true;

      try {
        const time_id =
          this.selectedTimeOption === "closest"
            ? this.availableTimes[0].periods[0].id
            : this.selectedDayTime;

        const res = await this.requesting(
          "preSessionRequests",
          "reserveTime",
          null,
          { time_id }
        );

        if (res.type === "success") {

          this.SendEventTrk({
            event_id: 'presession_' + Date.now(),
            name: 'pre_session_time',
            email: this.profile.email,
            first_name: this.profile.firstname,
            last_name: this.profile.lastname,
            payload: {}
          })

          this.$emit("change-step", 2);
          this.$emit("set-date", { date: this.finalDate, time_id });
        }
      } catch (e) {
        if (e?.response?.data?.data?.status === 1001) {
          this.timesRefreshed = true;
          this.loading = false;
          await this.fetchingTimes();
          this.emptyDayTimes();
          this.selectedTab = 0;
        } else {
          const msg =
            e?.response?.data?.message || this.$t('newPreSession.somethingWentWrong');
          this.$emitEvent("notify", { color: "red", title: msg });
        }
      } finally {
        this.$emitEvent("setLoading", false);
        this.loading = false;
      }
    },

    onSelectingTimeZone(e) {
      this.selectedTimeZone = e;
      this.timezoneDetailModal = false;
      let selectedDate = this.selectedDate;
      this.timezoneSearch = "";
      this.timezoneSearchResult = this.timezones;
      this.fetchingTimes(e);
      this.emptyDayTimes();
      this.generateDateTimes(selectedDate);
      this.selectedDayTime = null;
    },

    onTimezoneSearch() {
      if (this.throttleTimeout) clearTimeout(this.throttleTimeout);

      this.throttleTimeout = setTimeout(() => {
        const query = this.timezoneSearch.toLowerCase();
        this.timezoneSearchResult = this.timezones.filter((tz) =>
          (tz.text || "").toLowerCase().includes(query)
        );
      }, this.throttleDelay);
    },
    onHandleDaySelect(item) {
      this.selectedDayOfWeek = item;
      this.scrollToBottom();
    },

    scrollToBottom() {
      this.$nextTick(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      });
    },
  },
  mounted() {
    this.timezoneSearchResult = this.timezones;
    this.fetchingTimes();
  },
};
</script>

<style scoped>
.cautionContainer {
  width: auto;
  height: 32px;
  background-color: #ffedcf80;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 8px;
  padding: 4px;
}

.cautionImage {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}

@keyframes pulse-border {
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
}

.animateCaution {
  animation: pulse-border 1.5s ease-in-out infinite;
}

.selectedBorder {
  border: 1px solid #39c990 !important;
}

.timeSection {
  margin: 16px 24px;
}

.firstSection {
  background-color: white;
}

.eachSectionMargin {
  padding: 10px 24px;
  margin-top: 10px;
}

.sleeve {
  width: 18px;
  height: 22px;
  margin-left: 4px;
}

.leftArrow {
  width: 18px;
  height: 18px;
}

.sessionDetailRow {
  display: flex;
  flex: 1;
  margin-top: 11px;
  cursor: pointer;
}

.sessionDetailModal {
  width: 100%;
  height: 248px;
  padding: 0 24px;
  background-color: white;
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
}

.smallIcon {
  width: 20px;
  height: 20px;
}

.sessionDetailHeader {
  display: flex;
  flex-direction: row;
  padding: 16px 0;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #eaf0f6;
}

ul li {
  margin-right: 24px !important;
  margin-top: 3px !important;
}

.theInfoSection {
  margin-top: 16px;
}

.timezoneModal {
  width: 100%;
  height: 100vh;
  background-color: white;
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
  padding: 0 24px;
}

.timezoneInputWrapper :deep(.v-input__slot) fieldset {
  border-color: #eaf0f6 !important;
  border-width: 2px !important;
  border-radius: 12px !important;
}

.timezoneInputWrapper :deep(.v-input__slot):hover fieldset {
  border-color: #eaf0f6 !important;
  border-width: 2px !important;
}

.timezoneInputWrapper :deep(.v-input--is-focused .v-input__slot) fieldset {
  border-color: #3cbe8b !important;
  border-width: 2px !important;
}

.timezoneInputWrapper :deep(.v-text-field__details) {
  display: none !important;
}

.timezoneInput {
  margin-top: 16px;
  border-radius: 12px !important;
}

.searchIcon {
  width: 24px;
  height: 24px;
  margin-left: 4px;
}

.pageWrapper {
  max-height: 100vh;
}

.globeImg {
  width: 20px;
  height: 20px;
  margin-left: 7px;
}

.notebookImage {
  width: 21px;
  height: 22px;
  margin-left: 5px;
}
.notebookImageRtl {
  width: 21px;
  height: 22px;
  margin-right: 5px;
}

.eachBoxStyle {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  border: 1px solid #eaf0f6;
  transition: height 0.3s ease;
  padding: 12px 16px;
}

::v-deep .my-radio-group .v-radio,
::v-deep .my-radio-group .v-input__slot,
::v-deep .my-radio-group .v-input__control,
::v-deep .my-radio-group .v-messages,
::v-deep .my-radio-group .v-messages__wrapper {
  padding: 0 !important;
  margin: 0 !important;
  min-height: 0 !important;
}

.footerFixed {
  width: 100%;
  height: 101px;
  background-color: white;
  position: fixed;
  bottom: 0;
  padding: 24px 28px;
  box-shadow: 0 2px 8px #e4ecf6;
}

.submitBtn {
  cursor: pointer;
  background-color: #39c990;
  width: 170px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 12px;
}

.disabledDay {
  background-color: #f6f8fa !important;
  color: #bbb !important;
  pointer-events: none;
  opacity: 0.8;
}

.selectedDay {
  border: 1px solid #21c97a !important;
  background: linear-gradient(180deg, #fff 0%, #d7f4e9cc 80%) !important;
  box-shadow: 0 2px 8px #eaf0f6;
  border-radius: 12px;
  transition: border 0.2s, background 0.2s;
  color: #39c990;
}

.disabledDay * {
  color: #bbb !important;
}

.fourthSection {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.eachTimeBox {
  min-width: 90px;
  max-width: 84px;
  height: 90px;
  margin-left: 8px;
  border: 1px solid #dbe4ed;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
}

.bottomMargin {
  width: 100%;
  height: 200px;
}

.time-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.eachDayTime {
  width: 78px;
  height: 40px;
  border: 1px solid #dbe4ed;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 9px;
  margin-top: 8px;
  margin-left: 3px;
  cursor: pointer;
  direction: ltr;
}

.secondSection {
  background-color: white;
}

.thirdSection {
  background-color: white;
}

.fourthSection {
  background-color: white;
  margin-top: 0 !important;
}

.bottomSpacing {
  width: 100%;
  height: 230px;
  background-color: white;
}

.emptyImage {
  width: 170px;
  height: 162px;
}

.emptyPanel {
  padding-top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
}

.whatsAppSection {
  cursor: pointer;
  margin: 24px auto;
  width: 342px;
  height: 168px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: right;
  border: 1px solid #eaf0f6;
  border-radius: 8px;
  align-self: center;
  align-items: center;
}

.whatsAppButton {
  border: 1px solid #39c990;
  border-radius: 8px;
  width: 294px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  text-decoration: none !important;
  margin-top: 16px;
}

.whatsAppIcon {
  width: 24px;
  height: 24px;
  margin-left: 8px;
}

.submitBtn.is-disabled {
  background-color: #bdbdbd !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
  opacity: 0.8;
  pointer-events: none;
  transition: none;
}

.is-locked {
  opacity: 0.5;
  pointer-events: none;
  filter: grayscale(100%);
  transition: opacity 0.3s ease, filter 0.3s ease;
}
</style>
